interface PathnameSearchHash {
  pathname: string;
  search: string;
  hash: string;
}

export const getLocationPathSearchHash = (location: PathnameSearchHash = window.location): string => {
  const { pathname, search, hash } = location;
  return `${pathname}${search}${hash}`;
};
